export enum DialogTypes {
  None,
  Warning,
  Danger
}

export enum DialogWindowTypes {
  Dialog,
  Window,
  Required
}

export enum AnimationTypes {
  None,
  Bounce,
  Flash,
  Pulse,
  RubberBand,
  Shake,
  Swing,
  Tada,
  Wobble,
  BounceIn,
  BounceInLeft,
  BounceInRight,
  BounceInUp,
  FadeIn,
  FadeInDown,
  FadeInDownBig,
  FadeInLeft,
  FadeInLeftBig,
  FadeInRight,
  FadeInRightBig,
  FadeInUp,
  FadeInUpBig,
  Flip,
  FlipX,
  FlipY,
  LightSpeedIn,
  RotateIn,
  RotateInDownLeft,
  RotateInDownRight,
  RotateInUpLeft,
  RoateInUpRight,
  SlideInDown,
  SlideInLeft,
  SlideInRight,
  Rollin
}
